<template>
  <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="100" cy="100" r="100" fill="black" />
    <path d="M29.9274 53.3707L55.1637 53.3707L85.8992 127.358L73.4983 155.725L29.9274 53.3707Z" fill="white" />
    <path d="M93.4764 53.4029L118.713 53.195L149.448 127.946L137.047 156.314L93.4764 53.4029Z" fill="white" />
    <circle cx="164.162" cy="64.2793" r="13.1832" fill="white" />
    <path d="M164.366 95.6109L175.976 70.2718H152.349L164.366 95.6109Z" fill="white" />
    <rect width="38.6934" height="2.73936" rx="1.36968" transform="matrix(1 0 0 -1 23.5988 53.8356)" fill="white" />
    <rect width="38.6934" height="2.73936" rx="1.36968" transform="matrix(1 0 0 -1 87.289 53.8356)" fill="white" />
  </svg>
</template>

<script>
export default {};
</script>
